export const LC_COMPLETED_ACTIONS = 'completedActions';
export const LC_ON_HOLD_ACTIONS = 'onHoldActions';
export const LC_LAST_CONNECTION_TIME = 'lastConnectionTime';

export const API_URL = process.env.API_URL;
export const isLoginEnable = process.env.LOGIN_FEATURE === 'enable';
export const isPreProd = process.env.IS_PREPROD === 'true';
